<template>
    <b-card
        :header="uLang('app.agenda')"
        header-tag="h4"
        class="customer-following-system-table bg-default-card"
    >
        <div class="row">
            <div class="col-md-10">
                <multi-select
                    v-model="selectedStatusses"
                    :options="statusses"
                    :multiple="true"
                    :placeholder="uLang('app.choose_statusses')"
                    label="translated_name"
                    track-by="name">
                </multi-select>
            </div>
            <div class="col-md-2">
                <button
                    class="btn btn-block btn-brand"
                    @click.prevent="$emit('getTrajectories', selectedStatusIds)">
                    {{ uLang('app.filter') }}
                </button>
            </div>
        </div>
        <rea-loader :loading="loading"></rea-loader>
        <table class="customer-following-system-table table mt-4">
            <tr v-if="cardData.length === 0">
                <td colspan="4">{{ uLang('app.empty_table') }}</td>
            </tr>
            <tr v-if="cardData.length > 0">
                <th class="override-th-min-width"></th>
                <th>{{ uLang('app.customer') }}</th>
                <th>{{ uLang('app.trajectory') }}</th>
                <th>{{ uLang('app.next_action') }}</th>
                <th>{{ uLang('app.end_date') }}</th>
                <th>{{ uLang('app.snooze_date') }}</th>
            </tr>
            <tr v-for="trajectoryEnrolment in cardData"
                :style="[trajectoryEnrolmentEndDateIsInFuture(trajectoryEnrolment) ? {'background-color': 'rgba(255,10,10,0.1)'} : '']">
                <td>
                    <i class="ti-email pointer"
                       @click.prevent="sendLogToRelation(trajectoryEnrolment.relation)"
                    ></i>
                </td>
                <td>
                    <name-telephone-field
                        :relation="trajectoryEnrolment.relation"/>
                </td>
                <td>
                    <router-link
                        v-if="milestoneProgress(trajectoryEnrolment)"
                        :to="{
                            name: 'admin.relations.trajectory-enrolments.milestone-progresses.view',
                            params: {
                                'relationId': trajectoryEnrolment.relation.id,
                                'trajectoryEnrolmentId': trajectoryEnrolment.id,
                                'milestoneProgressId': milestoneProgress(trajectoryEnrolment).id,
                            }
                        }"
                    >
                        {{ trajectoryEnrolment.trajectory.name }}
                    </router-link>
                </td>
                <td>
                    <a v-if="milestoneProgress(trajectoryEnrolment) && actionProgress(trajectoryEnrolment)"
                        :href="$router.resolve({
                                name: 'admin.relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.update',
                                params: {
                                    'relationId': trajectoryEnrolment.relation_id,
                                    'trajectoryEnrolmentId': trajectoryEnrolment.id,
                                    'milestoneProgressId': milestoneProgress(trajectoryEnrolment).id,
                                    'actionProgressId': actionProgress(trajectoryEnrolment).id,
                                }
                            }).href"
                        target="_blank"
                        rel="noopener noreferrer">
                        {{ nextAction(trajectoryEnrolment).name }}
                    </a>
                </td>
                <td>
                    <template v-if="milestoneProgress(trajectoryEnrolment) && actionProgress(trajectoryEnrolment)">
                        {{ actionProgress(trajectoryEnrolment).due_date | date }}
                    </template>
                </td>
                <td>
                    {{ trajectoryEnrolment.relation.longest_snooze_date | date }}
                </td>
            </tr>
        </table>
        <b-modal
            class="log-modal-lg"
            :close-on-esc="false"
            :close-on-backdrop="false"
            :hideFooter="true"
            :title="uLang('app.add_type', { type: uLang('app.log') })"
            :key="log_form_key"
            ref="relationLogsModal"
            size="lg"
            v-if="($can('create-intern-logs')
                    || $can('update-intern-logs')
                    || $can('create-report-logs')
                    || $can('update-report-logs')
                    || $can('create-candidate-logs')
                    || $can('update-candidate-logs'))
            && relation_id !== null"
        >
            <log-form
                @logCreated="handleLogCreated"
                @categoryChanged="handleCategoryChanged"
                entityType="relations"
                :entityId="relation_id"
                :overrideEndpoint="logsFormApiUrl"
            />
        </b-modal>
    </b-card>
</template>
<script>
import {ReaLoader} from '~/components/helpers'
import MultiSelect from 'vue-multiselect'
import {DashboardFilter} from '~/mixins'
import {LogForm} from '~/components/forms'
import NameTelephoneField from "../../../elements/name-telephone-field";
import moment from "moment/moment";

export default {
    name: 'CustomerFollowSystem',

    components: {
        NameTelephoneField,
        ReaLoader,
        MultiSelect,
        LogForm
    },

    mixins: [
        DashboardFilter,
    ],

    props: {
        trajectoryData: {
            required: true,
        },
        loading: {
            required: true,
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            selectedStatusses: []
        }
    },

    methods: {
        getTrajectories() {
            return [];
        },
        milestoneProgress(trajectoryEnrolment) {
            return $getOrNull(['milestone_progresses', 0], trajectoryEnrolment)
        },
        actionProgress(trajectoryEnrolment) {
            return $getOrNull(['action_progresses', 0], this.milestoneProgress(trajectoryEnrolment))
        },
        nextAction(trajectoryEnrolment) {
            return $getOrNull(['action'], this.actionProgress(trajectoryEnrolment))
        },
        formatMoment(value) {
            return moment(value).locale(window.config.locale)
        },
        trajectoryEnrolmentEndDateIsInFuture(value) {
            let dateToUse = this.actionProgress(value).due_date

            if (value.relation.longest_snooze_date) {
                if (this.formatMoment(value.relation.longest_snooze_date).diff(this.formatMoment(moment(), 'days')) > 0) {
                    dateToUse = value.relation.longest_snooze_date;
                }
            }

            return moment(dateToUse).locale(window.config.locale).diff(moment(), 'days') < 0
        }
    },

    watch: {
        'trajectoryData.selectedStatusses'(val) {
            this.selectedStatusses = val;
        }
    },

    computed: {
        cardData() {
            if (!_.isEmpty(this.trajectoryData.trajectory_enrolments)) {
                // return this.trajectoryData.trajectory_enrolments;
                return this.trajectoryData.trajectory_enrolments.filter((enrolment) => {
                    return this.milestoneProgress(enrolment) !== null &&
                        this.actionProgress(enrolment) !== null;
                });
            }
            return [];
        },
        hasTrajectories() {
            return !_.isEmpty(this.trajectoryData.trajectory_enrolments)
        },
        statusses() {
            if (!_.isEmpty(this.trajectoryData)) {
                return this.trajectoryData.statusses
            }
            return [];
        },
        selectedStatusIds() {
            return _.map(this.selectedStatusses, 'name');
        },
    },
}
</script>
<style lang="scss">
    table.customer-following-system-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td, th {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }

    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
        min-height: 75px;
    }

    .override-th-min-width {
        min-width: 10px;
    }
</style>
